var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import { Widget } from '@web/components/layout/Widget';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { MeetingsByTimePeriodTooltip } from '@web/components/layout/WidgetTooltips/MeetingsByTimePeriodTooltip';
import { formatTimeRange, SimpleBarTimeline, TimelineTimeAxis, timeToMinutes } from '@web/components/ui/charts/SimpleBarTimeline';
import { useUserContext } from '@web/contexts/User';
import { trpc } from '@web/lib/trpc';
import { getUrl } from '@web/router/getUrl';
import { appsUrl, itemDetailsUrl } from '@web/router/urls';
import { classNames, isAiButtonDisabled, isInsightsDataEmpty } from '@web/utility';
import { formatChartDayPeriodAxisLabel } from '@web/utility/charts';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { appsActiveTabs } from '@web/utility/tabs';
import { ApplicationEnum, InsightTypeEnum } from '@workalizer/shared';
import { getInterval } from '@workalizer/shared/utils';
import { useTranslation } from 'react-i18next';
export var MeetingsByTimePeriod = function (_a) {
    var _b;
    var userId = _a.userId, orgUnitId = _a.orgUnitId, dateFrom = _a.dateFrom, dateTo = _a.dateTo;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var currentUser = useUserContext().currentUser;
    var _c = currentUser.workspace, startWorkingHour = _c.startWorkingHour, endWorkingHour = _c.endWorkingHour;
    var handleTimelineBarClick = function (periodRow, bar) {
        var _a;
        var meetings = (_a = bar.meetings) !== null && _a !== void 0 ? _a : [];
        if (meetings.length === 1) {
            navigateTo({
                pathname: itemDetailsUrl,
                newFilters: {
                    itemId: meetings[0].meetingId,
                    app: ApplicationEnum.MEET,
                    page: 1,
                    pageSection: null
                }
            });
            return;
        }
        navigateTo({
            pathname: getUrl(appsUrl, appsActiveTabs.searchMeetings),
            newFilters: {
                period: 'custom',
                dateFrom: periodRow.periodDateFrom,
                dateTo: periodRow.periodDateTo,
                user: userId,
                orgUnit: orgUnitId,
                app: ApplicationEnum.MEET,
                hasInitialSearch: true
            }
        });
    };
    var _d = trpc.meetingsByTimePeriod.useQuery({
        userId: userId,
        orgUnitId: orgUnitId,
        dateFrom: dateFrom,
        dateTo: dateTo
    }), meetingsByTimePeriod = _d.data, isLoading = _d.isLoading, refetch = _d.refetch;
    if (isLoading) {
        return _jsx(Loading, {});
    }
    var interval = getInterval(dateFrom, dateTo);
    var timelineData = meetingsByTimePeriod !== null && meetingsByTimePeriod !== void 0 ? meetingsByTimePeriod : [];
    var isTimelineEmpty = isInsightsDataEmpty(timelineData);
    var allTimelineItems = (_b = meetingsByTimePeriod === null || meetingsByTimePeriod === void 0 ? void 0 : meetingsByTimePeriod.flatMap(function (period) { return period.items; })) !== null && _b !== void 0 ? _b : [];
    var _e = allTimelineItems.reduce(function (acc, item) {
        var start = timeToMinutes(item.startTime);
        var end = timeToMinutes(item.endTime);
        return {
            start: start < timeToMinutes(acc.start) ? item.startTime : acc.start,
            end: end > timeToMinutes(acc.end) ? item.endTime : acc.end
        };
    }, {
        start: startWorkingHour,
        end: endWorkingHour
    }), axisTimelineStart = _e.start, axisTimelineEnd = _e.end;
    return (_jsxs("div", __assign({ className: "bg-white rounded-lg shadow-sm" }, { children: [_jsx(WidgetTitle, { title: t('app.performanceReview.employeePerformanceReview.communicationSection.employeeMeetingsByTimePeriod'), description: t('widgetTitleDescriptions.communication.employeeMeetingsByTimePeriod'), insightType: InsightTypeEnum.employeeMeetingsByTimePeriod, insightsData: meetingsByTimePeriod || [], refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.performanceReview.employeePerformanceReview.communicationSection.employeeMeetingsByTimePeriod'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, (meetingsByTimePeriod !== null && meetingsByTimePeriod !== void 0 ? meetingsByTimePeriod : []).flatMap(function (period) {
                                    return period.items.map(function (item) {
                                        var _a;
                                        return (_a = {},
                                            _a[t('filters.period')] = formatChartDayPeriodAxisLabel(period.period, interval, { dateFrom: dateFrom, dateTo: dateTo }),
                                            _a.Time = formatTimeRange(item.startTime, item.endTime),
                                            _a.Count = item.count,
                                            _a);
                                    });
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(meetingsByTimePeriod !== null && meetingsByTimePeriod !== void 0 ? meetingsByTimePeriod : []) }) }), _jsx(Widget, __assign({ cardClassName: "shadow overflow-x-auto overflow-y-visible border-b border-gray-200 sm:rounded-lg p-6", className: "lock w-full max-w-full py-2 align-middle sm:px-6 lg:pl-2 lg:pr-2" }, { children: _jsx("div", __assign({ className: "flex flex-col gap-4" }, { children: isTimelineEmpty ? (_jsx("div", __assign({ className: "py-2" }, { children: _jsx("div", __assign({ className: "flex h-8 w-full items-center justify-center rounded-md bg-gray-200", role: "status" }, { children: _jsx("span", __assign({ className: "text-sm text-gray-500" }, { children: t('widgetEmptyState.selectedPeriod') })) })) }))) : (meetingsByTimePeriod === null || meetingsByTimePeriod === void 0 ? void 0 : meetingsByTimePeriod.map(function (period, periodIdx) { return (_jsxs("div", __assign({ className: classNames('flex flex-col gap-2', periodIdx > 0 && 'mt-2') }, { children: [_jsx(TimelineTimeAxis, __assign({ timelineStart: axisTimelineStart, timelineEnd: axisTimelineEnd }, { children: _jsx("span", __assign({ className: "pointer-events-none absolute left-0 top-0 z-[1] max-w-[45%] truncate bg-white pr-2 text-left text-sm font-medium text-gray-700" }, { children: formatChartDayPeriodAxisLabel(period.period, interval, {
                                        dateFrom: dateFrom,
                                        dateTo: dateTo
                                    }) })) })), _jsx(SimpleBarTimeline, { items: period.items.map(function (item, idx) { return ({
                                    startTime: item.startTime,
                                    endTime: item.endTime,
                                    title: _jsx(MeetingsByTimePeriodTooltip, { item: item }),
                                    id: periodIdx * 1000 + idx,
                                    onBarClick: function () { return handleTimelineBarClick(period, item); }
                                }); }), barColor: "bg-emerald-500/60", timelineStart: axisTimelineStart, timelineEnd: axisTimelineEnd })] }), period.period)); })) })) }))] })));
};
